"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.KbArticleAuthoringInputSchema = exports.KbArticleBlocksInputSchema = void 0;
exports.prepareKbArticleAuthoring = prepareKbArticleAuthoring;
const zod_1 = require("zod");
const kb_article_blocks_1 = require("./kb-article-blocks");
const publication_contract_1 = require("./publication-contract");
exports.KbArticleBlocksInputSchema = zod_1.z.union([
    zod_1.z.array(kb_article_blocks_1.KbArticleBlockSchema),
    kb_article_blocks_1.KbArticleBlockDocumentSchema,
]);
exports.KbArticleAuthoringInputSchema = zod_1.z
    .object({
    title: zod_1.z.string().min(1),
    slug: zod_1.z.string().min(1),
    description: zod_1.z.string().min(1),
    summary: zod_1.z.string().min(1),
    blocks: exports.KbArticleBlocksInputSchema,
    status: publication_contract_1.PublicationStatusSchema.optional(),
    authorRowIds: zod_1.z.array(zod_1.z.string().min(1)).optional(),
    topicRowIds: zod_1.z.array(zod_1.z.string().min(1)).optional(),
    image: zod_1.z.unknown().optional(),
    imageAlt: zod_1.z.string().optional(),
    readTime: zod_1.z.number().int().min(1).optional(),
    publishedAt: zod_1.z.string().optional(),
    scheduledAt: zod_1.z.string().optional(),
    canonical: zod_1.z.string().optional(),
    locale: zod_1.z.string().optional(),
    noindex: zod_1.z.boolean().optional(),
})
    .strict();
function prepareKbArticleAuthoring(input) {
    const article = exports.KbArticleAuthoringInputSchema.parse(input);
    const publishedAt = article.status === 'published'
        ? (article.publishedAt ?? new Date().toISOString())
        : article.publishedAt;
    publication_contract_1.PublicationTimingSchema.parse({
        status: article.status ?? 'draft',
        publishedAt,
        scheduledAt: article.scheduledAt,
    });
    const blockDocument = Array.isArray(article.blocks)
        ? (0, kb_article_blocks_1.createKbArticleBlockDocument)(zod_1.z.array(kb_article_blocks_1.KbArticleBlockSchema).parse(article.blocks))
        : kb_article_blocks_1.KbArticleBlockDocumentSchema.parse(article.blocks);
    (0, kb_article_blocks_1.parsePublishableKbArticleBlockDocument)(blockDocument);
    const values = {
        title: article.title,
        slug: article.slug,
        description: article.description,
        summary: article.summary,
        blocks: (0, kb_article_blocks_1.serializeKbArticleBlocks)(blockDocument.blocks),
        body: (0, kb_article_blocks_1.extractKbArticlePlainText)(blockDocument),
        status: article.status ?? 'draft',
    };
    setOptional(values, 'author', article.authorRowIds);
    setOptional(values, 'topic', article.topicRowIds);
    setOptional(values, 'image', article.image);
    setOptional(values, 'imageAlt', article.imageAlt);
    setOptional(values, 'readTime', article.readTime);
    setOptional(values, 'publishedAt', publishedAt);
    setOptional(values, 'scheduledAt', article.scheduledAt);
    setOptional(values, 'canonical', article.canonical);
    setOptional(values, 'locale', article.locale);
    setOptional(values, 'noindex', article.noindex);
    return { blockDocument, articleValues: values };
}
function setOptional(target, key, value) {
    if (value !== undefined)
        target[key] = value;
}
